module.exports = __webpack_public_path__ + "img/yxlogo_white1.772e31c4.png";